import { useState, useEffect } from 'react';
import { FieldRow } from '../../shared';
import styles from './DeadlinesSection.module.css';

export interface DeadlinesData {
  early_bird_deadline: string | null;
  regular_deadline: string | null;
  final_deadline: string | null;
  winners_announcement_date: string | null;
  announcement_timeline: string | null;
  award_ceremony_date: string | null;
  submission_period: string | null;
  deadline_structure: string | null;
  qc_flag_deadlines: boolean | null;
  qc_flag_deadlines_notes: string | null;
}

export interface DeadlinesSectionProps {
  data: DeadlinesData;
  editable: boolean;
  onChange?: (updates: Partial<DeadlinesData>) => void;
}

export function DeadlinesSection({ data, editable, onChange }: DeadlinesSectionProps) {
  const [localData, setLocalData] = useState<DeadlinesData>(data);

  useEffect(() => {
    setLocalData(data);
  }, [data]);

  const handleFieldChange = (field: keyof DeadlinesData, value: string) => {
    const updates = { ...localData, [field]: value };
    setLocalData(updates);
    onChange?.(updates);
  };

  return (
    <div className={styles.container}>
      <div className={styles.fieldsContainer}>
        <FieldRow
          label="Submission Period"
          value={localData.submission_period}
          editable={editable}
          onChange={(v) => handleFieldChange('submission_period', v)}
        />
        <FieldRow
          label="Early Bird Deadline"
          value={localData.early_bird_deadline}
          editable={editable}
          onChange={(v) => handleFieldChange('early_bird_deadline', v)}
        />
        <FieldRow
          label="Regular Deadline"
          value={localData.regular_deadline}
          editable={editable}
          onChange={(v) => handleFieldChange('regular_deadline', v)}
        />
        <FieldRow
          label="Final Deadline"
          value={localData.final_deadline}
          editable={editable}
          onChange={(v) => handleFieldChange('final_deadline', v)}
        />
        <FieldRow
          label="Winners Announcement Date"
          value={localData.winners_announcement_date}
          editable={editable}
          onChange={(v) => handleFieldChange('winners_announcement_date', v)}
        />
        <FieldRow
          label="Announcement Timeline"
          value={localData.announcement_timeline}
          editable={editable}
          onChange={(v) => handleFieldChange('announcement_timeline', v)}
        />
        <FieldRow
          label="Award Ceremony Date"
          value={localData.award_ceremony_date}
          editable={editable}
          onChange={(v) => handleFieldChange('award_ceremony_date', v)}
        />
        <FieldRow
          label="Deadline Structure"
          value={localData.deadline_structure}
          editable={editable}
          onChange={(v) => handleFieldChange('deadline_structure', v)}
          multiline
        />
      </div>
    </div>
  );
}

export default DeadlinesSection;
